import { SVGProps } from 'react';

export const IconWarning = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M10.7211 2.50006L18.6597 16.2501C18.8898 16.6487 18.7533 17.1583 18.3547 17.3884C18.228 17.4616 18.0843 17.5001 17.938 17.5001H2.06087C1.60064 17.5001 1.22754 17.127 1.22754 16.6668C1.22754 16.5204 1.26605 16.3768 1.33919 16.2501L9.27776 2.50006C9.50785 2.10148 10.0175 1.96492 10.4161 2.19504C10.5428 2.26818 10.648 2.37338 10.7211 2.50006ZM9.1661 13.3334V15.0001H10.8328V13.3334H9.1661ZM9.1661 7.50006V11.6668H10.8328V7.50006H9.1661Z'
        fill='currentColor'
      />
    </svg>
  );
};
